// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
export { CobrandVanilaCarousel } from './CobrandVanilaCarousel';
